import React from 'react';
import Logo from './Logo';
import UserInfo from './UserInfo';
import decLogo from '../assets/dec-logo-icon.png';

// Custom panel toggle glyph per spec §10 — not from the icon set, a dedicated
// inline SVG: outer rounded rect, inner divider, filled left panel when open.
const PanelToggleIcon = ({ open, size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1.5" y="2.5" width="17" height="15" rx="2.5" stroke="currentColor" strokeWidth="1.5" />
    <path d="M7.5 2.5V17.5" stroke="currentColor" strokeWidth="1.5" />
    {open && <rect x="2.25" y="3.25" width="4.5" height="13.5" rx="1" fill="currentColor" />}
  </svg>
);

const Header = ({
  desktopSidebarOpen,
  onToggleDesktopSidebar,
  onOpenMobileSidebar,
  onLogout,
  userInfo,
}) => {
  return (
    <header
      className="fixed top-0 left-0 right-0 h-16 z-50 bg-shellBg text-shellText border-b border-shellBorder"
    >
      <div className="relative h-full flex items-center px-4 md:px-6">
        {/* Left zone */}
        <div className="flex items-center gap-3 min-w-fit z-[1]">
          <button
            type="button"
            className="hidden md:inline-flex items-center justify-center p-2 rounded-radiusSm text-shellText hover:bg-shellHover focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
            onClick={onToggleDesktopSidebar}
          >
            <span className="sr-only">{desktopSidebarOpen ? 'Hide sidebar' : 'Show sidebar'}</span>
            <PanelToggleIcon open={desktopSidebarOpen} />
          </button>
          <button
            type="button"
            className="md:hidden inline-flex items-center justify-center p-2 rounded-radiusSm text-shellText hover:bg-shellHover focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
            onClick={onOpenMobileSidebar}
          >
            <span className="sr-only">Open sidebar</span>
            <PanelToggleIcon open={false} />
          </button>
          <Logo position="left" className="hidden md:flex" />
        </div>

        {/* Center zone — absolutely centered brand, independent of side widths */}
        <div
          className="absolute left-1/2 top-1/2 flex items-center gap-2.5 pointer-events-none"
          style={{ transform: 'translate(-50%, -50%)' }}
        >
          <div className="h-11 w-11 flex items-center justify-center overflow-hidden flex-shrink-0">
            <img src={decLogo} alt="" className="w-full h-full object-contain" />
          </div>
          <div className="flex flex-col items-center">
            <span
              className="text-shellText font-bold text-base"
              style={{ letterSpacing: '0.3px', lineHeight: 1.15 }}
            >
              Data Modeling Copilot
            </span>
            <span
              className="hidden sm:block text-shellTextMuted text-center"
              style={{ fontSize: '0.65rem', fontWeight: 500, letterSpacing: '0.2px', lineHeight: 1.1, marginTop: '1px' }}
            >
              Model. Generate. Accelerate.
            </span>
          </div>
        </div>

        {/* Right zone */}
        <div className="flex items-center gap-3 ml-auto min-w-fit z-[1]">
          <Logo position="right" className="hidden md:flex" />
          <UserInfo userInfo={userInfo} onLogout={onLogout} />
        </div>
      </div>
    </header>
  );
};

export default Header;
